import { cn } from '@/lib/utils';
import { useApp, type CanvasMode } from '@/store/useApp';

const MODES: Array<{ id: CanvasMode; label: string; hint: string }> = [
  { id: 'select', label: 'Select', hint: 'Interact with the prototype' },
  { id: 'comment', label: 'Comment', hint: 'Click an element to attach a comment' },
  { id: 'edit', label: 'Edit', hint: 'Edit text in place' },
  { id: 'tweaks', label: 'Tweaks', hint: 'Adjust generated CSS variables' },
  { id: 'code', label: 'Code', hint: 'Edit the HTML/CSS source directly — saves as a new version' },
];

export function Toolbar() {
  const mode = useApp((s) => s.mode);
  const setMode = useApp((s) => s.setMode);

  return (
    <div
      role="tablist"
      aria-label="Canvas mode"
      className="flex items-center rounded-md border border-neutral-200 bg-white p-0.5 dark:border-neutral-800 dark:bg-neutral-950"
    >
      {MODES.map((m) => (
        <button
          key={m.id}
          role="tab"
          aria-selected={mode === m.id}
          title={m.hint}
          onClick={() => setMode(m.id)}
          className={cn(
            'rounded px-2 py-0.5 text-[11px] transition-colors',
            mode === m.id
              ? 'bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900'
              : 'text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-800',
          )}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
